import { render, staticRenderFns } from "./ExerciseStatistics.vue?vue&type=template&id=af876a94&"
import script from "./ExerciseStatistics.vue?vue&type=script&lang=js&"
export * from "./ExerciseStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports